



































































import { Vue, Component } from "vue-property-decorator";
import HelpCard from "./HelpCard.vue";

@Component({
  components: { HelpCard },
  name: "DifficultyChooser",
})
export default class DifficultyChooser extends Vue {
  showHelp = false;
  buttons = [
    { number: 4, label: "Easy", color: "green darken-4" },
    { number: 8, label: "Medium", color: "yellow darken-4" },
    { number: 12, label: "Hard", color: "red darken-4" },
  ];
}
